export const embedCode = (eventId, url) => `<script>
  (function() {
    if (!window.initBambuserLiveShopping) {

      window.initBambuserLiveShopping = function(item) { window.initBambuserLiveShopping.queue.push(item) };

      window.initBambuserLiveShopping.queue = [];
      var scriptNode = document.createElement('script');
      scriptNode['src'] = '${url}/default/embed.js';
      document.body.appendChild(scriptNode);
    }

    window.initBambuserLiveShopping({
      showId: '${eventId}',
      type: 'overlay',
    });
  })();
</script>`;

export const parseDevice = (device) => ({
  value: device.deviceId,
  // Removes trailing (xxxx:xxxx) from device labels.
  label: (device.label || device.deviceId).replace(/\s*\([0-9a-f]{4}:[0-9a-f]{4}\)/gi, '').trim(),
});
